import type { CertificationModule } from "@brookbush/types";

import useSWR, { type SWRResponse } from "swr";

import CertificationModuleTitle from "./CertificationCarouselTitle";
import CertificationCoursePlanButtons from "./CertificationCoursePlanButtons";
import CertificationNotifications from "./CertificationNotifications";
import CertificationProgress from "./CertificationProgress";
import Carousel from "~/components/Carousel";
import { useCertification } from "~/hooks";
import CoursesCard from "~/pages/courses/components/CoursesCard";

const CertificationOverview = () => {
	const { certification } = useCertification();

	const { data: modules } = useSWR(
		`/certifications/${certification.slug}/modules?courseLimit=6`,
	) as SWRResponse<CertificationModule[]> & {
		data: CertificationModule[];
	};

	return (
		<div className="flex w-full flex-col gap-4 phablet:gap-5">
			<h1 className="sr-only">{certification?.title}</h1>
			<div className="mt-1 flex laptop:hidden flex-col gap-4">
				<CertificationProgress />
				<CertificationCoursePlanButtons />
			</div>

			<CertificationNotifications />

			<div className="mt-1 phablet:-mt-1 flex w-full flex-col gap-5 phablet:gap-5">
				{modules
					.filter((module) => module.courses.length)
					.map((module) => (
						<Carousel
							title={
								<CertificationModuleTitle
									module={module}
									href={`/certifications/${certification.slug}/modules/${module.slug}`}
								/>
							}
							href={`/certifications/${certification.slug}/modules/${module.slug}`}
							key={module._key}
						>
							{module.courses.map((course) => (
								<CoursesCard key={course._id} {...course} />
							))}
						</Carousel>
					))}
			</div>
		</div>
	);
};

export default CertificationOverview;
